/* eslint-disable max-lines-per-function */
import React from "react";
import { Field, FormikValues } from "formik";
import { FormProps } from "../types";
import styles from "./update.module.css";

const ReviewForm: React.FC<FormProps> = () => (
  <Field name="overview">
    {({ form: { values } }: { form: { values: FormikValues } }) => (
      <>
        <h3>Personal Information</h3>

        <div className={styles.overviewDesc}>
            Number of people in your household (including you)
        </div>
        <div className={styles.overviewValue}>{values.householdCount}</div>

        <div className={styles.overviewDesc}>Current annual household income</div>
        <div className={styles.overviewValue}>{values.householdNetIncome}</div>

        {values.address1 && (
          <>
            <div className={styles.overviewDesc}>Mailing Address</div>
            <div className={styles.overviewValue}>{values.address1}</div>
            <div className={styles.overviewValue}>{values.address2}</div>
            <div
              className={styles.overviewValue}
            >{`${values.city}, ${values.state} ${values.zip}`}</div>
          </>
        )}

        {values.email && (
          <>
            <div className={styles.overviewDesc}>Email Address</div>
            <div className={styles.overviewValue}>{values.email}</div>
          </>
        )}

        {values.primaryPhone && (
          <>
            <div className={styles.overviewDesc}>Phone Number</div>
            <div className={styles.overviewValue}>
              {values.primaryPhone} <i>{values.primaryPhoneType}</i>
            </div>
          </>
        )}

        {values.secondaryPhone && (
          <>
            <div className={styles.overviewValue}>
              {values.secondaryPhone} <i>{values.secondaryPhoneType}</i> (Alternative)
            </div>
          </>
        )}

        <div className={styles.overviewDesc}>Optional contact?</div>
        {!values.contactRelation && <div className={styles.overviewValue}>No</div>}

        {values.contactRelation && (
          <>
            <div className={styles.overviewDesc}>Contact Name</div>
            <div className={styles.overviewValue}>{values.contactName}</div>

            <div className={styles.overviewDesc}>Contact Relation</div>
            <div className={styles.overviewValue}>{values.contactRelation}</div>

            <div className={styles.overviewDesc}>Contact Email Address</div>
            <div className={styles.overviewValue}>{values.contactEmail}</div>

            <div className={styles.overviewDesc}>Contact Phone</div>
            <div className={styles.overviewValue}>{values.contactPhone}</div>
          </>
        )}

        <div className={styles.overviewDesc}>
          {values.householdHasHousingAuthorityVoucher ? "Has" : "Does not have"} a Section 8 voucher
        </div>
      </>
    )}
  </Field>
);

export default ReviewForm;
